import React from 'react';
import classNames from 'classnames';
export function BuyDigital(_a) {
    var _b;
    var className = _a.className, style = _a.style, size = _a.size, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.weak, weak = _d === void 0 ? false : _d, number = _a.number, unit = _a.unit;
    return (React.createElement("div", { className: classNames('buy-digital', (_b = {},
            _b["buy-digital-" + size] = typeof size !== 'undefined',
            _b['buy-digital-disabled'] = disabled,
            _b['buy-digital-weak'] = weak,
            _b), className), style: style },
        React.createElement("span", { className: "buy-digital-num" }, number),
        React.createElement("span", { className: "buy-digital-unit" }, unit)));
}
//# sourceMappingURL=BuyDigital.js.map